<template>
  <g-field :label="skipLabel ? null : $t('label.jenis_pengeluaran')" :type="displayType" :message="displayMessage">
    <g-select :value="value" @input="onInput" :is-fullwidth="isFullwidth" :disabled="disabled"
              :placeholder="options.length === 0 ? $t('text.no_content_loaded') : $t('label.choose') + ' ' + $t('label.jenis_pengeluaran')">
      <option v-for="item in options" :key="item.id" :value="item.id">
        {{ getLabel(item) }}
      </option>
    </g-select>
  </g-field>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'annotation';
import Store from '../../../util/Store';
import GField from '../common/field/GField.vue';
import GSelect from '../common/select/GSelect.vue';

@Component({
  components: {
    'g-field': GField,
    'g-select': GSelect
  }
})
export default class JenisPengeluaranSelect extends Vue {

  @Prop({ default: null })
  public value: any;

  @Prop({ default: false, type: Boolean })
  public skipLabel: boolean;

  @Prop({ default: true, type: Boolean })
  public isFullwidth: boolean;

  @Prop({ type: String, default: null })
  public type: any;

  @Prop({ type: String, default: null })
  public message: any;

  @Prop({ type: Boolean, default: false })
  public disabled: any;

  public get options() {
    return Store.getVmProperty('jenisPengeluaran.data', []);
  }

  public get displayMessage() {
    const { message } = this;
    return typeof message === 'object' && message !== null ? message.message : message;
  }

  public get displayType() {
    const { message, type } = this;
    return typeof message === 'object' && message !== null ? message.type : type;
  }

  public async created() {
    await Store.dispatchJenisPengeluaran();
  }

  public onInput(val: any) {
    this.$emit('input', val);
    this.$emit('change', val);
  }

  public getLabel(item: any): string {
    const label = item.nama || item.name || item.id || 'DATA KOSONG';
    return String(label).toUpperCase();
  }
}
</script>
